import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import AdminAppointmentMain from "../transaksi/admin-appointment/AdminAppointmentMain";

const title = "Follow Up Appointment";

const AdminAppointmentPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return (
    <div className="p-4 w-full">
      <AdminAppointmentMain />
    </div>
    // return <div>Admin Appointment Page</div>;
  );
};

export default AdminAppointmentPage;
